// extracted by mini-css-extract-plugin
export default {"footerATag":"FooterMenuList_footerATag__+fxFb"};